const MIME_TYPES = {
  mp4: "video/mp4",
  mkv: "video/x-matroska",
};

// signal: an AbortController's, to stop the download, eg when the player closes
export async function fetchFile(url, title, { signal } = {}) {
  let blob = null;
  if (url) {
    try {
      // not from the cache: the <video> element's copy has no CORS headers, so Chrome would block reading it
      const response = await fetch(url, { cache: "no-store", signal });
      if (response.ok) {
        blob = await response.blob();
      }
    } catch {
      // fetch failed (e.g. CORS/network) or was aborted — download/share won't work but video still plays
    }
  }

  const pathname = url && new URL(url).pathname;
  const ext = pathname?.split(".").pop().toLowerCase();
  const basename = (title || "gloryleague").replace(/[^a-z0-9]+/gi, " ");
  const filename = ext ? `${basename}.${ext}` : basename;
  const mimeType = MIME_TYPES[ext];

  const file = blob && new File([blob], filename, { type: mimeType });
  const fileObjectUrl = file ? URL.createObjectURL(file) : null;

  return { filename, file, fileObjectUrl };
}
